import axios from "axios";

const dsdeRefURL = "/api/v1/dsdes_explore/reference_sources";

const dsdesExploreApi = {
  indexReferenceSources: id => axios.get(`${dsdeRefURL}/${id}`),
  createReferenceSources: (dsdeId, payload) =>
    axios.post(`${dsdeRefURL}/${dsdeId}`, { reference_source: payload }),
  getUniqueValuesOfDsde: (dsdeId, page = 1, per = 10) =>
    axios.get(
      `${dsdeRefURL}/${dsdeId}/get_unique_reference_values?page=${page}&per=${per}`
    ),
  createFromUniqueValues: (dsdeId, reference_source_id) =>
    axios.post(
      `${dsdeRefURL}/${dsdeId}/create_from_unique_values/${reference_source_id}`
    ),
  associateReferenceSources: (id, payload) =>
    axios.post(`${dsdeRefURL}/${id}/associate`, { reference_source: payload }),
  dissociateReferenceSource: (id, payload) =>
    axios.post(`${dsdeRefURL}/${id}/dissociate`, { reference_source: payload }),
};

export default dsdesExploreApi;
